module.exports = __webpack_public_path__ + "img/nacimientos-yaara.b3cca6d0.jpg";